import { render } from "./StoreDashboardView.vue?vue&type=template&id=699d1e74"
import script from "./StoreDashboardView.vue?vue&type=script&lang=js"
export * from "./StoreDashboardView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__